/** @format */

import { request } from '@power/runtime-vue3';
import type { BaseResponse } from '@power/runtime-vue3';

/**
 * @description 登录
 * @param {LoginParams} data
 * @returns
 */
export function login(data: API.LoginParams) {
	return request<BaseResponse<API.LoginResult>>(
		{
			url: 'login',
			method: 'post',
			data,
		},
		{
			isMock: true,
			isGetDataDirectly: false,
		},
	);
}

export function getPublicKey() {
	return request(
		{
			url: '/base/auth/getPublicKey',
			method: 'post',
		},
		{
			isGetDataDirectly: false,
		},
	);
}

export function getCaptchaApi() {
	return request(
		{
			url: '/base/auth/getCaptcha',
			method: 'get',
		},
		{
			isGetDataDirectly: false,
		},
	);
}

export function verifyCaptchaApi(data) {
	return request(
		{
			url: '/base/auth/verifyCaptcha',
			method: 'post',
			data,
		},
		{
			isGetDataDirectly: false,
		},
	);
}
//判断登录是否过期
export function grtIsExpiredReminder(data: any) {
	return request<BaseResponse<API.LoginResult>>(
		{
			url: '/base/system/licenseReminder/isExpiredReminder',
			method: 'post',
			data,
		},
		{
			isMock: false,
			isGetDataDirectly: false,
		},
	);
}

//是否超前提醒
export function getIsAdvanceReminder(data: any) {
	return request<BaseResponse<API.LoginResult>>(
		{
			url: '/base/system/licenseReminder/isAdvanceReminder',
			method: 'post',
			params: data,
		},
		{
			isMock: false,
			isGetDataDirectly: false,
		},
	);
}
